export default {
    // Menu Roles y Permisos
    id: '2',
    routeName: "default",//Ruta por default
    interface: 'b2b.offline',
    label: 'Evento',
    isInterface: true,
    items: [
        // Catalog
        {
            id: '2.1',
            label: 'Pedidos Evento',
            icon: "bx bxs-cart",
            permission: 'b2b.offline',
            routeName: 'event.offline',
            isTitle: true,
            selected: false,
            subItems: [
                {
                    id: '2.1.1',
                    label: 'Pedidos',
                    permission: 'b2b.offline',
                    routeName: "event.offline",
                    show: false
                },
            ]
        },
    ]
} 